import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateBatchesSlotService=async(data)=>{
    try {
        const result = await publicPost(`api/batches_slot/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateBatchesSlotService=async(data,id)=>{
    try {
        const result = await put(`api/batches_slot/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetBatchesSlotService=async(mode='')=>{
    try {
        const result = await get(`api/batches_slot/get?mode=${mode}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteBatchesSlotService=async(id)=>{
    try {
        const result = await deleteRequest(`api/batches_slot/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

